const initState = {
    // Can be used to show Loader component
    // loading: false,
    // Used to store 401 Error
    error: {},
    // Used to store 5XX errors
    serverError: {
        status: null,
        statusText: null,
    },
    // Beneficiary Email Address and Login status stored here
    details: {
        emailId: '',
        isLogged: false,
    },
    // Used to make Footer responsive on Internet Expolrer
    footerHeight: '40px',
    registeredUser: false,
    securityQuestion: { id: null, qid: null, question: null },

    //success message
    successMessage: {
        status: null,
        statusText: null,
    },

    sessionRefreshTimer: 0,
    //Mobile Details
    mobileDetails: {
        maskedMobileNo: null,
        mobileConfirmation: null,
    },

    //Allow Deletion for beneficiary details
    allowDelete: null,

    paymentDetails: {
        custId: null,
        tnxIds: null,
    },

    stagePaymentId: null,

    registrationDetails: {
        secDetails: null,
        password: null,
        confirmationPassword: null,
        saveDetails: null,
        autopay: null,
    },

    showTimeoutPopup: false,

    customerLogo: null,

    captchaConfig: {
        recaptchaEnabled: false,
        recaptchaKey: null,
    },

    captchaToken: null,

    calledLogoApi: false,
};

const beneDetailsReducer = (state = initState, action) => {
    console.log('Action called', action.type);
    switch (action.type) {
        case 'VALIDATE_CREDENTIALS_REQUEST':
            return {
                ...state,
                details: {
                    emailId: action.payload.emailId,
                },
            };
        case 'VALIDATE_CREDENTIALS_SUCCESS':
            return {
                ...state,
                details: action.payload,
                registeredUser: action.payload.registeredUser,
                mobileDetails: action.payload.mobileDetails,
                allowDelete: action.payload.allowDelete,
                captchaToken: null,
            };
        case 'VALIDATE_CREDENTIALS_FAILURE':
            return {
                ...state,
                error: action.payload,
                captchaToken: null,
            };
        case 'LOGOUT_REQUEST':
            return {
                ...state,
                loading: true,
            };
        case 'LOGOUT_SUCCESS':
            return {
                ...state,
                loading: false,
                details: action.payload,
                registeredUser: false,
                error: action.payload.error,
                mobileDetails: action.payload.mobileDetails,
                allowDelete: action.payload.allowDelete,
                customerLogo: action.payload.customerLogo,
                calledLogoApi: action.payload.calledLogoApi,
            };
        case 'LOGOUT_FAILURE':
            return {
                ...state,
                loading: false,
            };
        case 'CLEAR_ERROR_MESSAGE':
            return {
                ...state,
                error: {},
                successMessage: {},
            };
        case 'FOOTER_HEIGHT_CHANGED':
            return {
                ...state,
                footerHeight: action.payload,
            };
        case 'SERVER_ERROR':
            return {
                ...state,
                serverError: action.payload,
            };
        case 'SHOW_SECURITY_QUESTION':
            return {
                ...state,
                showSecurityError: action.payload,
            };
        case 'SET_SECURITY_QUESTION':
            return {
                ...state,
                securityQuestion: action.payload,
            };
        case 'RESET_SECURITY_QUESTION':
            return {
                ...state,
                securityQuestion: action.payload,
            };
        case 'SET_SUCCESS_MESSAGE':
            return {
                ...state,
                successMessage: action.payload,
            };
        case 'CLEAR_SUCCESS_MESSAGE':
            return {
                ...state,
                successMessage: action.payload,
            };
        case 'INCREMENT_SESSION_REFRESH_TIMER':
            return {
                ...state,
                sessionRefreshTimer: state.sessionRefreshTimer + 1,
            };
        case 'RESET_SESSION_REFRESH_TIMER':
            return {
                ...state,
                sessionRefreshTimer: 0,
            };
        case 'SET_CUSTID_TNXARRAY':
            return {
                ...state,
                paymentDetails: action.payload,
            };
        case 'RESET_CUSTID_TNXARRAY':
            return {
                ...state,
                paymentDetails: {
                    custId: null,
                    tnxIds: null,
                },
            };
        case 'SET_STAGE_PAYMENTID':
            return {
                ...state,
                stagePaymentId: action.payload,
            };
        case 'RESET_STAGE_PAYMENTID':
            return {
                ...state,
                stagePaymentId: null,
            };
        case 'SET_REGISTRATION_DETAILS':
            return {
                ...state,
                registrationDetails: action.payload,
            };
        case 'RESET_REGISTRATION_DETAILS':
            return {
                ...state,
                registrationDetails: {
                    secDetails: null,
                    password: null,
                    confirmationPassword: null,
                    saveDetails: null,
                    autopay: null,
                },
            };
        case 'TIMEOUT':
            return {
                ...state,
                loading: false,
                details: action.payload,
                registeredUser: false,
                error: action.payload.error,
                mobileDetails: action.payload.mobileDetails,
                showTimeoutPopup: action.payload.showTimeoutPopup,
            };
        case 'CLEAR_TIMEOUT_POPUP':
            return {
                ...state,
                showTimeoutPopup: false,
            };
        case 'SHOW_DELETE_LINK':
            return {
                ...state,
                allowDelete: action.payload,
            };
        case 'FETCH_CUSTOMER_LOGO':
            return {
                ...state,
                customerLogo: action.payload.customerLogo,
                calledLogoApi: action.payload.calledLogoApi,
                logoAltText: action.payload.logoAltText,
            };
        case 'REMOVE_CUSTOMER_LOGO':
            return {
                ...state,
                customerLogo: null,
            };
        case 'SET_CAPTCHA_CONFIG':
            return {
                ...state,
                captchaConfig: action.payload,
            };
        case 'SET_CAPTCHA_TOKEN':
            return {
                ...state,
                captchaToken: action.payload,
            };
        default:
            return state;
    }
};

export default beneDetailsReducer;
